/* Formats lineup (sections/st-formats.liquid). Works with st-tabs, which owns selection.
   - The five-star moment: when half the row of tiles is in view, every star lights up in turn,
     then they settle back to the chosen one.
   - The details settle in on each change, however it was made (a tap or the arrow keys), and on
     phones, where the row scrolls sideways, the chosen tile is brought into view.
   - On phones a swipe chooses too: when the row comes to rest, the tile at its start (or the last
     one, at the end) becomes the chosen format, so the details always match what is in front.
     Scrolls this script makes itself are not read as a swipe.
   No lighting and no settling under reduced motion; the scroll is instant there. */
(() => {
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root) => {
    if (root.dataset.stReady) return;
    root.dataset.stReady = '1';
    const row = root.querySelector('[data-st-tablist]');
    const tabs = () => [...root.querySelectorAll('[role="tab"]')];
    const current = () => tabs().findIndex((t) => t.getAttribute('aria-selected') === 'true');
    let ownScroll = false;
    let ownTimer;
    const onChange = () => {
      const tile = tabs()[current()];
      if (row && tile && row.scrollWidth > row.clientWidth + 1) {
        const r = row.getBoundingClientRect();
        const t = tile.getBoundingClientRect();
        if (t.left < r.left || t.right > r.right) {
          ownScroll = true;
          clearTimeout(ownTimer);
          ownTimer = setTimeout(() => (ownScroll = false), 900);
          row.scrollBy({ left: t.left - r.left - (r.width - t.width) / 2, behavior: RM ? 'auto' : 'smooth' });
        }
      }
      if (RM) return;
      const body = root.querySelector('.st-fmt__panel:not([hidden]) .st-fmt__body');
      if (!body) return;
      body.classList.remove('is-swap');
      void body.offsetWidth;
      body.classList.add('is-swap');
    };
    let last = current();
    new MutationObserver(() => {
      const now = current();
      if (now === last) return;
      last = now;
      onChange();
    }).observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    if (row) {
      let rest;
      const settle = () => {
        if (ownScroll) {
          ownScroll = false;
          return;
        }
        if (row.scrollWidth <= row.clientWidth + 1 || typeof root.select !== 'function') return;
        const tiles = tabs();
        let pick = tiles.length - 1;
        if (row.scrollLeft < row.scrollWidth - row.clientWidth - 2) {
          const start = row.getBoundingClientRect().left + (parseFloat(getComputedStyle(row).scrollPaddingInlineStart) || 0);
          let best = Infinity;
          tiles.forEach((t, k) => {
            const d = Math.abs(t.getBoundingClientRect().left - start);
            if (d < best) {
              best = d;
              pick = k;
            }
          });
        }
        if (pick !== current()) root.select(pick, false);
      };
      row.addEventListener(
        'scroll',
        () => {
          clearTimeout(rest);
          rest = setTimeout(settle, 140);
        },
        { passive: true }
      );
    }
    if (!RM && 'IntersectionObserver' in window && row) {
      const io = new IntersectionObserver(
        (en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          row.classList.add('is-lit');
          setTimeout(() => row.classList.remove('is-lit'), 1600);
        },
        { threshold: 0.5 }
      );
      io.observe(row);
    }
  };
  const run = () => document.querySelectorAll('[data-st-fmt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
